import service from '@/services/facturacion/otros'

const getDefaultState = () => ({
  list: [],
  contenido: {
    detalle: '',
    principal: '',
    valorPrincipal: '',
    estructura: []
  },
  currentRow: null
})

export const state = () => getDefaultState()

export const mutations = {
  SET_ROW: (state, row) => (state.currentRow = row),
  RESET_STATE: state => Object.assign(state, getDefaultState()),
  SET_CONTENIDO: (state, obj) => {
    state.contenido = obj
  },
  RESET_CONTENIDO: state => {
    state.contenido = {}
  },
  SET_OTRO_CONTENIDO: (state, objs) => {
    state.list = objs
  },
  SAVE_CHANGES: (state, obj) => {
    state.contenido = obj
  },
  RESET: state => {
    state.contenido = { ...getDefaultState().contenido }
  }
}

export const actions = {
  SET_ROW: (state, row) => (state.currentRow = row),
  create: async ({ commit, rootGetters }, item) => {
    // commit('SET_CONTENIDO', item)

    return service.create({ _idEmisor: await rootGetters['facturacion/emisorStore/get_Id'], ...item }).then(result => {
      return result
    })
  },

  readOtroContenidoByEmisor: async ({ commit, rootGetters }) =>
    service.readOtroContenidoByEmisor(await rootGetters['facturacion/emisorStore/get_Id']).then(result => commit('SET_OTRO_CONTENIDO', result)),
  delete: ({ commit }, items) => service.delete(items)
  // .then(result => {
  //   result.forEach(i => {
  //     if (i.state) commit('DELETE_LIST', i)
  //   })
  //   return result
  // })
}
